/*
 * @Author: Yun
 * @Date: 2023-12-13 14:22:38
 * @Last Modified by: Yun
 * @Last Modified time: 2024-03-05 10:09:29
 */

let files = [
    {
        type: 'IMAGE',
        source: require('@icons/btncppcc.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@icons/btnnpc.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@icons/favicon.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@icons/iconvideo.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@icons/close.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@icons/cgtn.jpg'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@icons/person1.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@icons/person2.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@icons/person3.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/pc.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/backgrounds/bg.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/firstPage/bg.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/firstPage/icon.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/firstPage/title.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/firstPage/txt.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/hotwords/bg.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/hotwords/txt1.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/hotwords/txt2.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/hotwords/txt3.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/hotwords/txt4.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/hotwords/txt5.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/hotwords/word1.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/hotwords/word2.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/hotwords/word3.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/hotwords/word4.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/hotwords/word5.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/intro/txt.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/congress/cppcc.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/congress/img1.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/congress/img2.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/congress/img3.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/congress/img4.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/congress/npc.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/congress/txt1.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/congress/txt2.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/congress/txt3.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/congress/txt4.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/submission/img1.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/submission/img2.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/submission/img3.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/submission/txtnpc1.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/submission/txtnpc2.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/submission/txtnpc3.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/submission/txtcppcc1.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/submission/txtcppcc2.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/submission/txtcppcc3.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/footer/share-img.png'),
        size: 100,
    },
    {
        type: 'IMAGE',
        source: require('@images/summary/tv.png'),
        size: 100,
    },
    {
        type: 'VIDEO',
        source: require('@videos/intro.mp4'),
        size: 100,
    },
    {
        type: 'VIDEO',
        source: require('@videos/submission1.mp4'),
        size: 100,
    },
    {
        type: 'VIDEO',
        source: require('@videos/submission2.mp4'),
        size: 100,
    },
    {
        type: 'VIDEO',
        source: require('@videos/submission3.mp4'),
        size: 100,
    },
    {
        type: 'VIDEO',
        source: require('@videos/summary.mp4'),
        size: 100,
    },
]

export { files }
